import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";
import starImg from "../../images/star.svg";

class ClientBody extends Component {
  render() {
    return (
      <div>
        {this.props.data.PrimaryContact && (
          <div className="primary-obj">
            <img alt="" src={starImg} />
            <span>Primary Contact</span>
          </div>
        )}
        <div className="data-line">
          <span>Client ID: </span>
          <span
            className="value-data"
            data-testid="client-page-client-id-label"
          >
            {this.props.data.ClientId}
          </span>
        </div>
        <div className="data-line">
          <span>
            {this.props.isPersonal ? "Client Name:" : "Business Name:"}{" "}
          </span>
          <span className="value-data">{this.props.data.BusinessName}</span>
        </div>
        {/* {this.props.data.DBA && <div className="data-line"><span>DBA: </span><span className="value-data">{this.props.data.DBA}</span></div>} */}
        {this.props.data.Website && (
          <div className="data-line">
            <span>Website: </span>
            <span className="value-data">
              {FormatUtils.formatRef(this.props.data.Website)}
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default ClientBody;
